<template>
  <div id="app" :style="{background:`url(${bodyBackgroundUrl}) repeat-x`}">
    <router-view> </router-view>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data () {
      return {
        bodyBackgroundUrl: process.env.VUE_APP_API_URL + 'r/cms/www/default/img/index/bg1.jpg'
      }
    },
  }
</script>

<style>
  #app {
    min-height: 100%;
    font-family: "微软雅黑";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue